export var FormSource;
(function (FormSource) {
    FormSource["Divorce"] = "divorce";
    FormSource["Ai"] = "ai";
})(FormSource || (FormSource = {}));
export var FormAnswerType;
(function (FormAnswerType) {
    FormAnswerType["FreeText"] = "free-text";
    FormAnswerType["YesNo"] = "yes-no";
    FormAnswerType["MultipleChoice"] = "multiple-choice";
    FormAnswerType["Numeric"] = "numeric";
    FormAnswerType["Date"] = "date";
    FormAnswerType["Time"] = "time";
    FormAnswerType["DateTime"] = "datetime";
})(FormAnswerType || (FormAnswerType = {}));
export var QuestionType;
(function (QuestionType) {
    QuestionType["Text"] = "text";
    QuestionType["FreeText"] = "free-text";
    QuestionType["YesNo"] = "yes-no";
    QuestionType["Numeric"] = "numeric";
    QuestionType["Financial"] = "financial";
    QuestionType["Date"] = "date";
    QuestionType["Time"] = "time";
    QuestionType["SplitDate"] = "split-date";
    QuestionType["DateTime"] = "datetime";
    QuestionType["Radio"] = "radio";
    QuestionType["Checkbox"] = "checkbox";
    QuestionType["MultiPart"] = "multi-part";
    QuestionType["Scale"] = "scale";
    QuestionType["Items"] = "items";
    QuestionType["File"] = "file";
    QuestionType["Email"] = "email";
    QuestionType["Phone"] = "phone";
})(QuestionType || (QuestionType = {}));
export var ClientIntakeFormType;
(function (ClientIntakeFormType) {
    ClientIntakeFormType["Generic"] = "generic";
    ClientIntakeFormType["Divorce"] = "divorce";
    ClientIntakeFormType["AIGenerated"] = "ai-generated";
})(ClientIntakeFormType || (ClientIntakeFormType = {}));
export var IntroductoryFormType;
(function (IntroductoryFormType) {
    IntroductoryFormType["Divorce"] = "divorce";
    IntroductoryFormType["AIGenerated"] = "ai-generated";
})(IntroductoryFormType || (IntroductoryFormType = {}));
//# sourceMappingURL=form.js.map